import { SR_API_ACTION_PRE_LEASE_GET_BY_LISTING_ID } from 'api/actionTypes';

export default async function getByListingId(
  { state, apiClient },
  { listingId, forceRefresh = false },
) {
  const statePath = ['preLeases', 'byListingId', listingId];
  if (state.get(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PRE_LEASE_GET_BY_LISTING_ID,
    state: state,
    payload: {
      listingId,
    },
    onSuccess(preLease) {
      state.set(statePath, preLease);
    },
  });
}
